module.exports = __webpack_public_path__ + "img/65293383002807.f2c48a00.png";